// Price and Summary
export const PRICE_COMPONENT = "price-component";
export const RENDERED_PRICE = "renderedPrice";
export const BUTTON_SUMMARY = "button-summary";
export const ADD_TO_BASKET = "add-to-basket";

// Main Navigation Tabs
export const TAB_CONFIGURE = "tab-configure";
export const TAB_SPECS_AND_HIGHLIGHTS = "tab-specs-and-highlights";
export const TAB_SPECS = "tab-specs";
export const TAB_HIGHLIGHTS = "tab-highlights";

// Steps
export const SPECS_AND_HIGHLIGHTS_STEP = "specs-and-highlights-step";
export const CONFIGURE_LBX_STEP = "configure-lbx-step";
export const CONFIGURE_STEP = "configure-step";
export const HIGHLIGHTS_STEP = "highlights-step";
export const SPECS_STEP = "specs-step";
export const STEP_NAVIGATION = "step-navigation";

// Configuration Options
export const COLOUR_SWATCH = "colour-swatch";
export const UPHOLSTERY_NAME = "upholstery-name";
export const UPHOLSTERY_ITEM = "upholstery-item";
export const MOTORIZATION_CARD = "motorization-card";

// Add-on Components
export const EXTRAS_WRAPPER = "extras-wrapper";
export const EXTRA_ADD_TO_BASKET_BUTTON = "extra-add-to-basket-button";
export const PACKS_WRAPPER = "packs-wrapper";
export const PACK_ADD_TO_BASKET_BUTTON = "pack-add-to-basket-button";
export const WHEEL_ADD_TO_BASKET_BUTTON = "wheel-add-to-basket-button";
export const WINTERWHEEL_ADD_TO_BASKET_BUTTON = "winterwheel-add-to-basket-button";

// Dynamic IDs

/** data-testid={sectionId}
 * src/new-cars/apheleia/carconfig/components/lexus/common/section-wrapper/SectionWrapper.tsx
 * src/new-cars/apheleia/carconfig/components/lexus/configure-lbx/sections/atmosphere/subsections/SubSectionWrapper.tsx
 * src/new-cars/apheleia/carconfig/components/toyota/configure/sections/SectionWrapper.tsx
 */

/** data-testid={tabId}
 * src/new-cars/apheleia/carconfig/components/lexus/common/summary/overview/SummaryOverview.tsx
 * src/new-cars/apheleia/carconfig/components/toyota/configure/sections/summary/overview/SummaryOverview.tsx
 */

/** data-testid={`navigate-${section}`}
 * src/new-cars/apheleia/carconfig/components/toyota/configure/ConfigureNavigationButton.tsx
 */
